import { PostHeaderElement } from '@components/Post';
import { mc } from '@styles';
import React, { FC, useState } from 'react';
import Fade from 'react-reveal/Fade';

import ChevronDown from './assets/chevron-down.inline.svg';
import ChevronUp from './assets/chevron-up.inline.svg';

interface Props {
  contents: PostHeaderElement[];
  active?: string;
  onItemClick?: (itm: PostHeaderElement) => void;
}

export const PostTableOfContentsMobileDropdown: FC<Props> = ({ onItemClick, contents, active }) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleItemClick = (itm: PostHeaderElement) => {
    setOpen(false);
    onItemClick && onItemClick(itm);
  };

  const renderItem = (itm: PostHeaderElement) => (
    <li
      key={itm.id}
      className={mc(`px-5 py-3 leading-4 bg-white`, 'text-sm text-ocean-blue', active === itm.id ? 'font-bold' : 'font-medium')}
      onClick={() => handleItemClick(itm)}
    >
      <a href={`#${itm.id}`}>{itm.text}</a>
      {itm.subitems && itm.subitems.length > 0 && (
        <ul className="bg-white list-disc list-inside">{itm.subitems.map(renderSubitem)}</ul>
      )}
    </li>
  );

  const renderSubitem = (itm: PostHeaderElement) => (
    <li
      key={itm.id}
      className={mc(`px-5 py-3 leading-4 bg-white`, 'text-sm text-accent-blue', active === itm.id ? 'font-bold' : 'font-medium')}
      onClick={() => handleItemClick(itm)}
    >
      <a href={`#${itm.id}`}>{itm.text}</a>
    </li>
  );

  const activeItem = contents.find(itm => itm.id === active);

  const renderTitle = () => {
    if (activeItem) return activeItem.text;
    if (contents.length) return contents[0].text;
    return '';
  };

  return (
    <div className="relative flex flex-col justify-center items-center px-6">
      <a
        className={mc(
          'py-3 leading-4 px-5 border-neutral-gray border w-full rounded-lg text-sm font-bold font-raleway flex flex-row items-center justify-between',
          open && 'rounded-bl-none rounded-br-none',
        )}
        role="button"
        onClick={() => setOpen(!open)}
      >
        <span className="block pr-8">{renderTitle()}</span>
        <div className="shrink-0 w-6">{open ? <ChevronUp /> : <ChevronDown />}</div>
      </a>
      {open && (
        <Fade duration={150}>
          <div style={{ top: '100%' }} className="absolute px-6 w-full z-10">
            <ul className={`bg-white rounded-bl-lg rounded-br-lg border border-neutral-gray overflow-hidden`}>
              {contents.map(renderItem)}
            </ul>
          </div>
        </Fade>
      )}
    </div>
  );
};

export default PostTableOfContentsMobileDropdown;
